module.exports = __webpack_public_path__ + "img/mxr-deep-phase.e8737529.jpg";